<mat-card id="card" fxLayout="column" class="mainContentBody">
    <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
        <h2>Comunicazioni</h2>
        <div fxLayout="column" class="responsive-mat-form">
          <!-- Collaboratore field -->
          <mat-form-field>
            <mat-label>Collaboratore</mat-label>
            <mat-select [(ngModel)]="parameters.collaboratore" [disabled]="!isJappTenantAdmin()" [compareWith]="compareDTO">
              <mat-option [value]="null">
                  Tutti
              </mat-option>
              <mat-option *ngFor="let collaboratore of collaboratori" [value]="collaboratore">
                {{collaboratore.nome}} {{collaboratore.cognome}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Filter field -->          
          <mat-form-field>
            <input matInput [(ngModel)]="parameters.filter" placeholder="Filter"/>
          </mat-form-field>
        </div>
        <mat-card-actions>
          <button mat-raised-button id="search-button" (click)="list()" name="Search" color="primary">Search</button>
          <button mat-raised-button id="new-button" [routerLink]="['/comunicazione/detail/0']" [disabled]="!isJappTenantAdmin()">New</button>
        </mat-card-actions>
        <br/>
        <div *ngIf="parameters.showList" fxLayout="column">
          <table mat-table fxFlex matTableExporter #exporter="matTableExporter" [hiddenColumns]="hiddenColumns()"
            matSort (matSortChange)="setSort($event)" matSortDisableClear 
            [dataSource]="parameters.dataSource">

            <!-- ID Column -->
            <ng-container matColumnDef="id">
              <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
              <td fxHide fxShow.gt-md mat-cell *matCellDef="let comunicazione"> {{comunicazione.id}} </td>
            </ng-container>
        
            <!-- Titolo Column -->
            <ng-container matColumnDef="titolo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Titolo </th>
              <td mat-cell *matCellDef="let comunicazione"> {{comunicazione.titolo}} </td>
            </ng-container>

            <!-- Collaboratore Column -->
            <ng-container matColumnDef="collaboratore">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Collaboratore </th>
              <td mat-cell *matCellDef="let comunicazione"> {{comunicazione.collaboratore?.nome}} {{comunicazione.collaboratore?.cognome}} </td>
            </ng-container>

            <!-- Titolo Column -->
            <ng-container matColumnDef="descrizione">
              <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> Descrizione </th>
              <td fxHide fxShow.gt-md mat-cell *matCellDef="let comunicazione"> {{comunicazione.descrizione}} </td>
            </ng-container>

            <!-- URL Column -->
            <ng-container matColumnDef="url">
              <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> URL </th>
              <td fxHide fxShow.gt-md mat-cell *matCellDef="let comunicazione"> {{comunicazione.url}} </td>
            </ng-container>              
        
            <ng-container matColumnDef="detail">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let comunicazione">
                  <button mat-mini-fab color="primary" [routerLink]="['/comunicazione/detail/', comunicazione.id]"><mat-icon>search</mat-icon></button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <mat-card-actions>
              <button mat-raised-button (click)="exporter.exportTable('xlsx', {fileName:'comunicazioni'})">Excel</button>
              <button fxHide fxShow.gt-md mat-raised-button (click)="exporter.exportTable('csv', {fileName:'comunicazioni'})">Csv</button>
              <button fxHide fxShow.gt-md mat-raised-button (click)="exporter.exportTable('json', {fileName:'comunicazioni'})">Json</button>
            </mat-card-actions>
            <mat-paginator [pageSize]="parameters.pageSize" [pageIndex]="parameters.pageNumber" [length]="parameters.length" [pageSizeOptions]="[10,50,100]" (page)="setPaginator($event)"></mat-paginator>
          </div>
        </div>
    </mat-card-content>
  </mat-card>